/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartConfigurationPanel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2zm2 2v16h10V4zm12 0v16h4V4zm3 4h-2V6h2zm-7-1v11h-2V7zm-4 4v7H6v-7zm11 2h-2v-2h2zm0 5h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartConfigurationPanel as ChartConfigurationPanel };
